import React, { JSX } from 'react';
import Styles from './GiftConfigV2.module.scss';
import ToolTip from '../ToolTip/ToolTip';

const GiftConfigV2 = ({ content }: any): JSX.Element => {
  return (
    <div>
      <div className={Styles.giftcontainer}>
        <div className={Styles.giftlist}>
          {content?.giftIcon && content?.giftIcon?.filename && (
            <span className={Styles.gifticon}>
              <img src={content?.giftIcon?.filename} width={24} height={24} alt='giftIcon' />
            </span>
          )}
          <span className={Styles.gifttitle}>{content?.title}</span>
          <span className={Styles.gifttooltip}>
            {content?.tooltipText && <ToolTip content={content?.tooltipText} isBenefit={true} />}
          </span>
        </div>
        <div className={Styles.list}>
          <div className={Styles.giftlist}>
            <div className={Styles.giftsection}>
              {content?.giftIcon && (
                <span className={Styles.gifticon}>
                  <img src={content?.giftImage?.filename} width={64} height={64} alt='giftIcon' />
                </span>
              )}
              <div className={Styles.giftdescription}>
                <span className={Styles.description}>{content?.giftName}</span>
                <br />
                <span className={Styles.giftprice}>{content?.price}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default GiftConfigV2;
